import React from 'react'
import './CellExpanderFormatter.scss'
import { VehicleOrderStatus } from '../../../helpers/Orders'
import { hasTimeElapsed } from '../../../helpers/Utils'
import { useTranslation } from 'react-i18next'

export interface CellExpanderFormatterProps {
  level: number
  column?: number
  value?: string
  expanded: boolean
  status: VehicleOrderStatus
  onCellExpand: () => void
  isConfirmationExpiring: boolean
  isUndelivered: boolean
  isInternalUser: boolean
  earliestDelivery?: string
  freeze?: string
}

export function CellExpanderFormatter({
  level,
  column,
  value,
  status,
  onCellExpand,
  isConfirmationExpiring,
  isUndelivered,
  isInternalUser,
  earliestDelivery,
  freeze,
}: CellExpanderFormatterProps) {
  const { t } = useTranslation('common')

  function handleClick(e: React.MouseEvent<HTMLSpanElement>) {
    e.stopPropagation()
    onCellExpand()
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLSpanElement>) {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault()
      onCellExpand()
    }
  }

  const hide =
    (level === 1 && column === 0) ||
    (level === 0 && column === 1) ||
    (level === 2 && column === 1) ||
    (level === 2 && column === 0)

  const maxDurationPassed = hasTimeElapsed(earliestDelivery, 45)
  const isPendingConfirmation =
    status === VehicleOrderStatus.PendingDeliveryConfirmation && !maxDurationPassed ? true : false
  const isUndeliveredInternal = isUndelivered && isInternalUser
  const isExpiring =
    isConfirmationExpiring && status !== VehicleOrderStatus.Delivered && (isInternalUser || !maxDurationPassed)
  const orderAlert = isUndeliveredInternal || isExpiring

  const frozenOrder =
    !!freeze &&
    hasTimeElapsed(freeze, 0) &&
    !earliestDelivery &&
    status !== VehicleOrderStatus.Delivered &&
    status !== VehicleOrderStatus.Delivering

  return (
    <span
      title={value}
      className={`rdg-cell-expand ${hide ? 'hide' : 'show'}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      {value}
      {/* level {level} column {column} */}
      {status && (
        <span
          className={`orderStatus ${
            orderAlert ? 'statusAlert' : isPendingConfirmation ? 'statusIssue' : 'statusNeutral'
          }`}
          title={
            frozenOrder ? t('FROZEN_ORDER') : orderAlert || isPendingConfirmation ? t('ACTION_REQUIRED') : undefined
          }
        >
          <i
            className={`${
              frozenOrder ? 'icon-delivery' : orderAlert || isPendingConfirmation ? 'icon-warning' : 'icon-info'
            }`}
          />
        </span>
      )}
    </span>
  )
}
